import { useState } from "react";
import slide1 from "../images/slide1.webp";
import slide2 from "../images/slide2.webp";
import slide3 from "../images/slide3.webp";
import { Link } from "react-router-dom";



const plans = [
  {
    id: "eco",
    name: "Plan Eco",
    description: "Servicios funerarios amigables con el medio ambiente.",
    image: slide1,
  },
  {
    id: "estandar",
    name: "Plan Estándar Tradicional",
    description: "Servicios funerarios tradicionales con una variedad de opciones de ataúd.",
    image: slide2,
  },
  {
    id: "silver",
    name: "Plan Silver",
    description: "Servicios mejorados con opciones adicionales para la personalización.",
    image: slide1,
  },
  {
    id: "black",
    name: "Plan Black",
    description: "Servicios premium con personalización completa y opciones de lujo.",
    image: slide2,
  },
  {
    id: "golden",
    name: "Plan Golden",
    description: "Servicios de lujo con beneficios exclusivos y asistencia personalizada.",
    image: slide3,
  },
];

export default function ServicePlans() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-gray-100">
  <section className="container mx-auto max-w-6xl space-y-8">
    <div className="flex flex-col mb-0">
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-left text-gray-900">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700">
          Nuestros planes de servicios
        </span>
      </h2>
      <p className="mt-2 text-base sm:text-lg lg:text-xl text-gray-600 text-left">
        Brindamos múltiples planes de servicios para asegurar un homenaje que respete y celebre la vida de quienes han partido.
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 ">
      {plans.map((plan, index) => (
        <div
          key={index}
          className="border  rounded-lg overflow-hidden shadow-lg transition-all duration-300 ease-in-out"
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <div className="relative overflow-hidden">
            <img
              src={plan.image}
              alt={plan.name}
              className="w-full h-40 sm:h-48 lg:h-64 object-cover transition-transform duration-300 ease-in-out lg:hover:scale-110"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 sm:bg-opacity-40 flex items-center justify-center">
              <h3 className="text-white text-xl sm:text-2xl lg:text-3xl font-extrabold ">
                {plan.name}
              </h3>
            </div>
          </div>
          <div className="p-4 sm:p-4">
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 text-justify">
              {plan.description}
            </p>
          </div>
                    <div className="p-4 sm:p-4">

                {/* Enlace a la página específica del plan */}
                <Link
                  to={`/PlanesDeServicio/${plan.id}`}
                  
                >
                  <button
              className={`w-full py-2 px-4 border rounded-md font-medium transition-all focus:outline-none focus:ring-2 focus:ring-[#DBAC5B] ${
                hoveredIndex === index
                  ? "bg-[#DBAC5B] text-[#A0A0A0]  border-[#A0A0A0]"
                  : "bg-[#DBAC5B] text-[#fff] border border-[#A0A0A0]"
              }`}
            >
              Más información
            </button>
                </Link>
          </div>
        </div>
      ))}
    </div>
  </section>
</div>

  );
}
